import { inject, injectable } from 'inversify';
import { TYPES } from '@Types';
import { magic_item_full } from '@Api';
import { MagicItem } from '@Models';
import { ModelRuleCategoryMapper } from './ModelRuleCategoryMapper';

@injectable()
export class MagicItemMapper {
  @inject(TYPES.Mapper.ModelRuleCategoryMapper)
  private _modelRuleCategoryMapper!: ModelRuleCategoryMapper;

  public map(item: magic_item_full): MagicItem {
    return {
      id: item.id,
      name: item.name ?? '',
      points: item.value_points,
      description: item.description ?? '',
      disable_magic_path_limit: item.disable_magic_path_limit,
      modelRuleCategories:
        item.model_rule_categories?.map((item) =>
          this._modelRuleCategoryMapper.map(item),
        ) ?? [],
      is_dominant: item.is_dominant,
      magic_item_category_id: item.magic_item_category_id,
      max: item.max,
      only_foot: item.only_foot,
      requiredOrganisationIds: item.required_organisation_ids ?? [],
    } satisfies MagicItem as MagicItem;
  }
}
